import { RootState } from "store";

export const customer           = (state:RootState) => state.customer.customer;
export const activeDispensary   = (state:RootState) => state.cart.activeDispensary;
export const profilePreferences = (state:RootState) => state.profile.preferences;
export const medicalDispensaries = (state:RootState) => state.cart.medicalDispensaries;
